import { BaseDto } from '../base.dto';
import { IsDefined, IsInt, IsNumber, IsOptional, IsString, Length, Matches, ValidateIf } from 'class-validator';
import { Exclude } from 'class-transformer';
import { MerchantDto } from '../merchant.dto';
import { EmployeeDto } from '../employee.dto';
import { MerchantServiceTimesDto } from '../merchantServiceTimes.dto';
import { validationPatterns } from '../../constants';

export class BankingGratuityDto extends BaseDto {
  @IsDefined()
  @IsInt()
  merchantId: number;

  @ValidateIf(o => o.merchantServiceTimeId != null)
  @IsInt()
  merchantServiceTimeId?: number;

  @IsDefined()
  @IsInt()
  lastModifiedEmployeeId: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  amount: number;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description: string;

  @IsOptional()
  @Exclude()
  lastModifiedEmployee?: EmployeeDto;

  @IsOptional()
  @Exclude()
  merchant?: MerchantDto;

  @IsOptional()
  @Exclude()
  merchantServiceTime?: MerchantServiceTimesDto;

}
